module.exports = __webpack_public_path__ + "img/gpay.17708cb2.png";